import apiClient from "./apiClient";

export interface AdminProfile {
  id: string;
  name: string;
  email: string;
  profilePicture: string | null;
  role: { id: string; name: string };
}

interface GetProfileResponse {
  message: string;
  admin: AdminProfile;
}

/** Fetch the logged-in admin profile (includes profile picture path). */
export const getAdminProfile = async (signal?: AbortSignal): Promise<AdminProfile> => {
  const response = await apiClient.get<GetProfileResponse>("profile", { signal });
  return response.data.admin;
};
